// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__b8XzW","requiredAsterisk":"Info_requiredAsterisk__1mM7s"};